import request from '../tools/request'
import { HTTP } from './http'
const { GET } = request

// 任务中心参数
interface TaskCenterParam {
  pageNo?: number
  pageSize?: number
  supplierId: string
}
// 获取任务列表
export const GET_TASKLIST = (param: TaskCenterParam) =>
  GET(`${HTTP}/mission/getMissionPage`, param)

// 任务详情
interface TaskDetailParam {
  id: string // 任务id
  pageNo: number
  pageSize: number
}
// 获取任务详情
export const GET_TASKDETAIL = (param: TaskDetailParam) =>
  GET(`${HTTP}/mission/getMissionDetailPage`, param)
import request from '../tools/request'
import { HTTP } from './http'
const { GET } = request

// 任务中心参数
interface TaskCenterParam {
  pageNo?: number
  pageSize?: number
  supplierId: string
}
// 获取任务列表
export const GET_TASKLIST = (param: TaskCenterParam) =>
  GET(`${HTTP}/mission/getMissionPage`, param)

// 任务详情
interface TaskDetailParam {
  id: string // 任务id
  pageNo: number
  pageSize: number
}
// 获取任务详情
export const GET_TASKDETAIL = (param: TaskDetailParam) =>
  GET(`${HTTP}/mission/getMissionDetailPage`, param)
